import styled, { css } from 'styled-components';

import { theme, breakpoints } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';

export const Container = styled.div``;

export const FlexWrapper = styled.div<{
  hideGiftIcon: boolean;
  newDesign: boolean;
}>`
  @media screen and (min-width: ${breakpoints.sm}) {
    display: flex;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    display: ${({ hideGiftIcon }) => (hideGiftIcon ? 'flex' : 'inline-block')};
  }

  align-items: center;

  ${({ newDesign }) =>
    newDesign
      ? css`
          padding: 1rem 0;
        `
      : css`
          padding: 1rem 1.25rem 1rem 0;
        `}
`;

export const IconTextWrapper = styled.div<{ newDesign: boolean }>`
  display: flex;

  @media screen and (min-width: ${breakpoints.sm}) {
    padding-right: 0.5rem;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    padding-bottom: 1rem;
  }

  ${({ newDesign }) =>
    !newDesign &&
    css`
      flex-basis: 90%;
    `}
`;

export const IconWrapper = styled.div`
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
  text-align: center;
`;

interface IImageWrapperProps {
  touch: boolean;
  showImageInRowOnMobile: boolean;
}

export const ImageWrapper = styled.div<IImageWrapperProps>`
  width: 4.375rem;
  height: 4.375rem;
  align-items: center;
  justify-content: center;

  display: ${(props: IImageWrapperProps) => (props.touch ? 'flex' : 'none')};
  @media (hover: hover) {
    display: ${(props: IImageWrapperProps) => (props.touch ? 'none' : 'flex')};
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    justify-content: flex-start;
    margin-top: 0.3125rem;
    margin-left: 2.25rem;
    ${({ showImageInRowOnMobile }) => !showImageInRowOnMobile && 'width: 100%'};
  }
`;

export const GiftImg = styled(CdnImage)`
  max-width: 4.375rem !important;
  max-height: 4.375rem !important;
  overflow: hidden;
`;

export const GiftImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;

  img {
    overflow: hidden;
  }

  @media (hover: hover) {
    width: 18.75rem;
    height: 18.75rem;
    max-width: 100%;

    img {
      max-width: 18.75rem;
      max-height: 18.75rem;
    }
  }
`;

export const Content = styled.div`
  flex: 10;
  color: ${(props) => props.theme.palette.neutralDarker};
  font-size: 0.875rem;
  line-height: 1.313rem;
`;

export interface ITitleProps {
  giftImage: boolean;
  newPdDesignEnabled: boolean;
}

export const Title = styled.div`
  text-transform: uppercase;
  color: ${(props: ITitleProps) =>
    props.giftImage ? theme.palette.primary : theme.palette.basic};

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
        `}
`;

export const Description = styled.div<{ newDesign: boolean }>`
  a {
    color: ${(props) => props.theme.palette.basic};
    text-decoration: underline;
  }
  a:hover {
    text-decoration: none;
  }
  ${({ newDesign }) =>
    newDesign &&
    css`
      margin-top: 0.25rem;
      ${theme.typography.bodyRegular}
    `}
`;
